/**
 * DigiWedge Shared Spacing Tokens
 * Consistent spacing scale for layout and components.
 */
// =============================================================================
// Spacing Scale (in pixels for mobile, can be converted to rem for web)
// =============================================================================
export const spacing = {
    /** 4px */
    xs: 4,
    /** 8px */
    sm: 8,
    /** 12px */
    md: 12,
    /** 16px */
    lg: 16,
    /** 24px */
    xl: 24,
    /** 32px */
    xxl: 32,
    /** 48px */
    xxxl: 48,
    /** 64px */
    xxxxl: 64,
};
// =============================================================================
// CSS Variables (for web)
// =============================================================================
export const spacingCss = {
    xs: '8px',
    sm: '16px',
    md: '24px',
    lg: '32px',
    xl: '48px',
    xxl: '64px',
};
// =============================================================================
// Border Radius
// =============================================================================
export const radii = {
    none: 0,
    sm: 4,
    md: 8,
    lg: 12,
    xl: 16,
    full: 9999,
};
// =============================================================================
// Accessibility - Touch Targets
// =============================================================================
/**
 * Minimum touch target size per accessibility guidelines
 * iOS: 44x44, Android: 48x48
 * We use 44 as the minimum for cross-platform consistency
 */
export const MIN_TOUCH_TARGET = 44;
//# sourceMappingURL=spacing.js.map